import { isInstantInCalendarDateRange } from '../utils/calendarDate.js';

export function columnFilterHasValue(column, filterValue) {
  if (column.dataType === 'enum') {
    return filterValue && Object.values(filterValue).some(Boolean);
  }
  if (column.dataType === 'date') {
    return filterValue && (filterValue.startDate || filterValue.endDate);
  }
  return filterValue != null && String(filterValue).trim() !== '';
}

export function isColumnFilterActive(column, filterValue, disabledFilters) {
  return columnFilterHasValue(column, filterValue) && !disabledFilters.has(column.key);
}

export function rowPassesColumnFilter(row, column, filterValue) {
  const value = column.getValue(row);

  switch (column.dataType) {
    case 'text':
      if (!value) return false;
      return String(value).toLowerCase().includes(filterValue.toLowerCase());

    case 'date':
      if (!value) return false;
      return isInstantInCalendarDateRange(value, filterValue.startDate, filterValue.endDate);

    case 'enum': {
      const hasAnySelection = Object.values(filterValue).some(Boolean);
      if (!hasAnySelection) return true;
      if (!value) return !!filterValue[''];
      return !!filterValue[value];
    }

    default:
      return true;
  }
}

export function applyColumnFilters(data, columns, filterValues, disabledFilters) {
  if (!Array.isArray(data)) return data;

  return data.filter(row =>
    columns.every(column => {
      const filterValue = filterValues[column.key];
      if (!isColumnFilterActive(column, filterValue, disabledFilters)) return true;
      return rowPassesColumnFilter(row, column, filterValue);
    })
  );
}

export function applyColumnSort(data, columns, sortState) {
  if (!Array.isArray(data)) return data;
  if (!sortState.columnKey || !sortState.direction) return data;

  const column = columns.find(col => col.key === sortState.columnKey);
  if (!column || !column.sortable) return data;

  return [...data].sort((a, b) => column.compare(a, b, sortState.direction));
}

export function filterAndSortTableData(data, columns, { filterValues = {}, disabledFilters = new Set(), sortState = {} } = {}) {
  const filtered = applyColumnFilters(data, columns, filterValues, disabledFilters);
  return applyColumnSort(filtered, columns, sortState);
}
